/*
 * @Author: your name
 * @Date: 2020-11-23 10:05:07
 * @LastEditTime: 2021-02-19 17:32:33
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\assets\scripts\flvPlayer.js
 */
import flvjs from 'flv.js'
export function liveKommander(videoElement, url) {
  if (flvjs.isSupported()){
    let flvPlayer = flvjs.createPlayer({
      type: 'flv',
      enableWorker: true, //浏览器端开启flv.js的worker,多进程运行flv.js
      isLive: true, //直播模式
      hasAudio: true, //关闭音频
      hasVideo: true,
      stashInitialSize: 256,
      enableStashBuffer: true, //播放flv时，设置是否启用播放缓存，只在直播起作用。
      url: url
    });
    flvPlayer.attachMediaElement(videoElement);
    flvPlayer.load();
    // flvPlayer.play();
    return flvPlayer;
  } else {
    this.$msg({
      message: '请使用谷歌浏览器！',
      type: 'warning'
    });
  }
}
